import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { TenantContractContext } from "@eres/ejari-core/contexts/TenantContractContext";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router";
import PageContent from "@my-dld/components/PageContent";
import { extractPropInfo } from "../../../component/PropertyHeader";
import DocumentInfo from "../../../component/TenantContract/DocumentInfo";
import TerminateInfo from "../../../component/TenantContract/TerminateInfo";
import EjariPageTitle from "../../../component/EjariPageTitle";
import Strings from "@my-dld/assets/strings";
import TCProcessMarker from "../../../component/TenantContract/TCProcessMarker";

interface Props extends RoutedViewProps {

}

interface State {

}

class TerminateTenantContract extends Component<Props, State> {
	static contextType = TenantContractContext;
	context!: React.ContextType<typeof TenantContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	render() {
		const pp = this.props.match.url;
		const { property } = this.context;
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		const { val, lbl } = extractPropInfo( property );
		return <PageContent
			title={ `${ Strings.terminate_contract } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<EjariPageTitle title={ Strings.terminate_contract }/>
			<div className={ "ejari-contract" }>
				<Switch>
					<Route
						path={ pp + "/start" }
						render={ ( props: RouteComponentProps<any> ) => {
							return <TCProcessMarker
								{ ...props }
								to={ pp + "/info" }
								done={ pp + "/success" }
							/>;
						} }/>
					<Route path={ pp + "/info" } exact={ true } component={ TerminateInfo }/>
					<Route path={ pp + "/documents" } component={ DocumentInfo }/>
					<Route path={ pp } exact={ true }>
						<Redirect to={ pp + "/start" }/>
					</Route>
				</Switch>
			</div>
		</PageContent>;
	}
}

export default TerminateTenantContract;
